import { useState } from 'react'
import { FollowButtonProps, WithFollowButtonProps } from './interface'

export function withFollowButton(Component: React.FC<FollowButtonProps>) {
  function WithFollowButton(props: WithFollowButtonProps) {
    const [hover, setHover] = useState(false)

    function handleMouseFocus() {
      setHover(true)
    }

    function handleMouseBlur() {
      setHover(false)
    }

    const componentProps = {
      ...props,
      hover,
      handleMouseFocus,
      handleMouseBlur,
    }
    return <Component {...componentProps} />
  }

  return WithFollowButton
}
